// One-line admin-config audit: writes an admin_config_changed entry to the
// top-level adminAuditLog collection, attributed to the signed-in user.
// Coarse by design — configArea + a short human summary, no field diffs.
import { auth } from '../firebase';
import { addAdminAuditLogEntry } from './firestoreService';
import userTeamService from './userTeamService';

export function logAdminConfigChange(configArea, summary, extraDetails = {}) {
  const userEmail = auth.currentUser?.email || null;
  addAdminAuditLogEntry({
    userId: userEmail,
    userDisplayName: userEmail ? userTeamService.getUserName(userEmail) : null,
    details: { configArea, summary, ...extraDetails },
  }).catch(() => {});
}
